"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signer = exports.InMemorySigner = void 0;
var signers_1 = require("@near-js/signers");
Object.defineProperty(exports, "InMemorySigner", { enumerable: true, get: function () { return signers_1.InMemorySigner; } });
Object.defineProperty(exports, "Signer", { enumerable: true, get: function () { return signers_1.Signer; } });
